var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isIdle && !_vm.isSignedOut )?_c('idle-state',{on:{"onSignOut":(val)=>_vm.isSignedOut = val}}):_vm._e(),_c('div',{attrs:{"id":"app2"}},[_c('router-view'),_c('saving-animation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSaving),expression:"isSaving"}]}),_vm._v(";\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }